import {io} from "socket.io-client";

// export const API_URL = "http://localhost:8052/api";
// export const IMAGE_URL = "http://localhost:8052";
// export const SOCKET = io("http://localhost:8051");

export const API_URL = "https://apitrello.on365.ru/api";
export const IMAGE_URL = "https://admintrello.on365.ru";
export const SOCKET = io("https://sockettrello.on365.ru");